import { Link } from "react-router-dom";
import { PublicFooter, PublicNav } from "@/components/PublicNav";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/pages/Landing";

export default function FAQ() {
  return (
    <div className="min-h-screen">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
        <p className="overline text-primary">faq</p>
        <h1 className="mt-4 text-4xl sm:text-5xl font-display font-black tracking-tighter leading-none">
          Frequently asked
        </h1>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {FAQ_ITEMS.map(([q, a], i) => (
            <AccordionItem key={q} value={`f${i}`} data-testid={`faq-full-${i}`}>
              <AccordionTrigger className="text-left text-sm font-medium">{q}</AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-14 border border-border p-8">
          <h2 className="font-display text-xl font-bold tracking-tight">Still deciding?</h2>
          <p className="mt-2 text-sm text-muted-foreground">Take the free assessment — the score report alone tells you what to study next.</p>
          <Link to="/register" className="inline-block mt-6" data-testid="faq-cta">
            <Button className="rounded-none">Start free assessment</Button>
          </Link>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
